import type { ReactNode } from "react";

export function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

export function shortenChip(s: string, max = 22): string {
  if (!s) return "";
  if (s.length <= max) return s;
  const cut = s.slice(0, max).replace(/\s+\S*$/, "");
  return cut + "…";
}

/**
 * Splits a tagline like "Foo — bar" or "Foo, bar" into a (head, tail) pair so the
 * UI can italicize/gradient the tail. Returns null when there's no natural split,
 * in which case callers should italicize the full string or the last ~third.
 */
export function splitTagline(s: string): { head: string; tail: string } | null {
  const str = String(s || "").trim();
  let m;
  if ((m = str.match(/^(.+?)\s*—\s*(.+)$/))) return { head: m[1], tail: m[2] };
  if ((m = str.match(/^(.+?)\s+--\s+(.+)$/))) return { head: m[1], tail: m[2] };
  if ((m = str.match(/^(.+?),\s*(.+)$/))) return { head: m[1] + ",", tail: m[2] };
  return null;
}

export function renderTagline(s: string): ReactNode {
  const split = splitTagline(s);
  if (split) {
    return (
      <>
        {split.head}{" "}
        <em>{split.tail}</em>
      </>
    );
  }
  const words = String(s || "").trim().split(" ");
  if (words.length <= 6) return <em>{s}</em>;
  const tail = Math.min(4, Math.max(2, Math.floor(words.length / 3)));
  return (
    <>
      {words.slice(0, -tail).join(" ")} <em>{words.slice(-tail).join(" ")}</em>
    </>
  );
}

export function extractModuleNumber(platformRole: string): string {
  const m = (platformRole || "").match(/Module\s*(\d+)/i);
  return m ? "M" + pad2(parseInt(m[1], 10)) : "M••";
}

export function platformShortLabel(platformRole: string): string {
  return (platformRole || "").split("·")[0].trim();
}

